import { render } from "./Flag.vue?vue&type=template&id=74f865dd&scoped=true"
import script from "./Flag.vue?vue&type=script&lang=js"
export * from "./Flag.vue?vue&type=script&lang=js"

import "./Flag.vue?vue&type=style&index=0&id=74f865dd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-74f865dd"

export default script